import { onUnmounted } from "vue";

export interface Disposable {
  dispose(): void,
}

export default function useDisposer () {
  const disposables: Array<Disposable> = [];

  function autoDispose<T> (disposable: T & Disposable): T {
    disposables.push(disposable);
    return disposable;
  }

  function dispose () {
    disposables.forEach((disposable) => {
      disposable.dispose();
    });

    disposables.length = 0;
  }

  onUnmounted(() => {
    dispose();
  });

  return {
    autoDispose,
  };
}
